import { BaseButton, type BaseButtonProps } from '@/components/common/base-button';
import clsx from 'clsx';
import styles from './styles.module.scss';

interface ShopFnbFacilityFloorButtonProps extends BaseButtonProps {
    title: string;
    isVertical: boolean;
    onClick: () => void;
    classes: string;
}

const ShopFnbFacilityFloorButton = ({ title, isVertical, 'aria-checked': ariaChecked, onClick, classes, ...props }: ShopFnbFacilityFloorButtonProps) => {
    return (
        <BaseButton
            className={clsx(styles['floor-button'], { [styles['floor-button--active']]: ariaChecked, [styles['floor-button--vertical']]: isVertical })}
            onClick={onClick}
            aria-checked={ariaChecked}
            {...props}
        >
            <span className={classes}>{title}</span>
        </BaseButton >
    );
};

export default ShopFnbFacilityFloorButton;
